<cdk-virtual-scroll-viewport #viewport itemSize="10" (scroll)="onScroll.emit($event)">
	<ng-content></ng-content>
</cdk-virtual-scroll-viewport>
